// extracted by mini-css-extract-plugin
export default {"jsonView":"src-components-atom-jsonView-jsonView-module__jsonView--swfTh"};